module.exports = __webpack_public_path__ + "img/title.c022a453.png";